var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoGoogle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5297",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5297",
    width: 24,
    height: 24,
    transform: "translate(293)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_\\u043C\\u0430\\u0441\\u043E\\u043A_168",
    "data-name": "\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430 \\u043C\\u0430\\u0441\\u043E\\u043A 168",
    transform: "translate(-293)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-google",
    transform: "translate(293 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245772",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245772",
    d: "M28.567,14.45H27.6V14.4H16.8v4.8h6.782a7.206,7.206,0,1,1-2.005-7.777l3.394-3.394A11.988,11.988,0,1,0,28.8,16.8,12.082,12.082,0,0,0,28.567,14.45Z",
    transform: "translate(-4.8 -4.8)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245773",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245773",
    d: "M7.567,11.215l3.943,2.891a7.185,7.185,0,0,1,11.45-2.683l3.394-3.394A11.976,11.976,0,0,0,7.567,11.215Z",
    transform: "translate(-6.184 -4.8)",
    fill: "#ff3d00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245774",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245774",
    d: "M18.117,43.232a11.944,11.944,0,0,0,8.045-3.115l-3.714-3.143a7.181,7.181,0,0,1-11.1-3.31L7.434,36.68A11.991,11.991,0,0,0,18.117,43.232Z",
    transform: "translate(-6.117 -19.232)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_245775",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 245775",
    d: "M40.567,24.05H39.6V24H28.8v4.8h6.782a7.224,7.224,0,0,1-2.452,3.343h0l3.714,3.143A11.608,11.608,0,0,0,40.8,26.4,12.082,12.082,0,0,0,40.567,24.05Z",
    transform: "translate(-16.8 -14.4)",
    fill: "#1976d2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGoogle);
export default __webpack_public_path__ + "static/media/ico_google.2a20f74a75402ef139b507543b616bf2.svg";
export { ForwardRef as ReactComponent };